import "flatpickr/dist/themes/material_blue.css";
import "../../../assets/scss/datatables.scss";

import * as confirmAction from "../../../store/confirm/action";
import * as loadingAction from "../../../store/loading/action";
import * as messageAction from "../../../store/message/action";

import {
    Button,
    Card,
    CardBody,
    CardTitle,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    InputGroup,
    Label,
    Modal,
    Nav,
    NavItem,
    NavLink,
    Row,
    TabContent,
    TabPane,
    Table,
} from "reactstrap";
import {
    GET_ACCOUNT,
    GET_ONSHORE_RP_TPA_DAILY_REPORT,
    GET_RP_TPA_DAILY_REPORT,
    SAVE_LIST_EVENT_RP_TPA_DAILY_REPORT,
    SAVE_LIST_SHRINKAGE_RP_TPA_DAILY_REPORT,
    SAVE_ONSHORE_RP_TPA_DAILY_REPORT,
    SAVE_RP_TPA_DAILY_REPORT,
    SAVE_STOCK_RP_TPA_DAILY_REPORT,
    RP_TPA_SEND_MAIL,
} from "../../../helpers/url_api_constant";
import { Link, useHistory, useParams } from "react-router-dom";
import React, { createRef, useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { getPermission, getUserToken } from "../../../helpers/auth_helper";
import { post, postUpload } from "../../../helpers/api_helper";

import OveruseByContact from "./OveruseByContact";
import OveruseByShipper from "./OveruseByShipper";
import PropTypes from "prop-types";
import Select from "react-select";
import TableFour from "./TableFour";
import TableOne from "./TableOne";
import TableThree from "./TableThree";
import TableTwo from "./TableTwo";
import logoPttColor from "../../../assets/images/PTT_LogoColor.png";
import moment from "moment";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { flatMapDeep } from "lodash";

function TabTwoTPADailyDetail(props) {
    // console.log(props);
    let history = useHistory();
    let { pid } = useParams();
    // console.log(pid);
    // const tpaDailyReducer = useSelector(reducer => reducer.TPADailyReport);
    const dispatch = useDispatch();
    const permission = getPermission();
    const [modelDevice, setModelDevice] = useState({});


    //onInit//
    useEffect(function () {
        if (props.tpaDailyReportPid != null) {
            fetchData();
        }
    }, [props.tpaDailyReportPid]);
    //onInit//

    const gotoMainMenu = () => {
        history.push({
            pathname: "/tpa-daily-report", state: {  // location state
                goBack: true,
            },
        });
    };

    //Function CURL

    const fetchData = async () => {
        // dispatch(loadingAction.showLoading());
        let searchModel = { PID: props.tpaDailyReportPid }
        try {
            let res = await post(GET_RP_TPA_DAILY_REPORT, searchModel);
            // console.log(res);
            let data = res.data.rpTPADailyList[0];
            // console.log(data);
            setModelDevice({
                ...data, REMARK: data.REMARK == null ? "" : data.REMARK, TPADAILY_LEVEL: data.TPADAILY_LEVEL == null ? "" : data.TPADAILY_LEVEL
            });
        } catch (error) {
            dispatch(messageAction.showMessage(error.message));
        }
        // dispatch(loadingAction.hideLoading());
    };

    useEffect(() => {
        // console.log(modelDevice);
    }, [modelDevice]);

    // const SelectStyle = {
    //     option: (provided, { data, isDisabled, isFocused, isSelected }) => ({
    //         ...provided,
    //         ...isFocused && ({ backgroundColor: '#2E3460' })
    //     }),
    // }

    return (
        <React.Fragment>

            <Col xl="12" className="align-items-center justify-content-center">
                <Card className="mb-0">
                    {props.tpaDailyReportPid != null && (
                        <CardBody>

                            <Row>
                                <Col
                                    sm="6"
                                    className="d-flex align-items-center justify-content-start"
                                >
                                    <span style={{ fontSize: "17px", color: "#FFFFFF" }}> Date : </span>&nbsp;&nbsp;<span style={{ fontSize: "17px", color: "#556ee6" }}>{modelDevice.SUMMARYREPORT_DATE == undefined ? "" : moment(modelDevice.SUMMARYREPORT_DATE).locale('en')
                                        .format(
                                            "DD/MM/YYYY"
                                        )}</span>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <span style={{ fontSize: "17px", color: "#FFFFFF" }}> Shipper : </span>&nbsp;&nbsp;<span style={{ fontSize: "17px", color: "#556ee6" }}>{modelDevice.BALANCESHIPPER_NAME}</span>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <span style={{ fontSize: "17px", color: "#FFFFFF" }}> Revision : </span>&nbsp;&nbsp;<span style={{ fontSize: "17px", color: "#556ee6" }}>{modelDevice.SUMMARYREPORT_REV}</span>
                                </Col>
                                {/* <hr /> */}

                                <Col
                                    sm="6"
                                    className="d-flex align-items-center justify-content-end"
                                >
                                    <div className="d-grid gap-2 d-md-block">
                                        <Button
                                            onClick={() => gotoMainMenu()}
                                            // className="btn-rounded"
                                            color="secondary"
                                            className="mt-1 mb-0"
                                        >
                                            <i className="fas fa-angle-double-left"></i>
                                            &nbsp; Back
                                        </Button>
                                    </div>
                                </Col>
                            </Row>

                            <Row>
                                <div className="media align-items-center mt-2">
                                    <img
                                        src={logoPttColor}
                                        alt=""
                                        style={{ maxWidth: "190px" }}
                                        className="mx-auto d-block" //img-thumbnail
                                    />
                                </div>
                            </Row>

                            <Row>
                                <label className="d-sm-flex align-items-center justify-content-center mt-2" style={{ fontSize: "18px", color: "#FFFFFF" }}>
                                    รายงาน สรุปข้อมูลการบริหารปริมาณก๊าซ สมุดรายวัน และ ความสามารถในการให้บริการรายวันของ Shipper ประจำวันที่ &nbsp;&nbsp;
                                    <span style={{ fontSize: "17px", color: "#556ee6" }}>{modelDevice.SUMMARYREPORT_DATE == undefined ? "" : moment(modelDevice.SUMMARYREPORT_DATE).locale('en').add(-1,'day')
                                        .format(
                                            "DD/MM/YYYY"
                                        )}</span>
                                </label>
                            </Row>

                            <Row>
                                <label className="d-sm-flex align-items-center justify-content-start mt-3" style={{ fontSize: "18px", color: "#FFFFFF" }}>
                                    1. สรุปข้อมูลการบริหารปริมาณก๊าซในระบบท่อส่งก๊าซธรรมชาติบนบก
                                </label>
                            </Row>

                            <Row>
                                <label className="d-sm-flex align-items-center justify-content-start mt-3 ms-5" style={{ fontSize: "16px", color: "#FFFFFF" }}>
                                    ตารางที่ 1 สรุปเหตุการณ์สำคัญที่กระทบต่อการบริหารปริมาณก๊าซ
                                </label>
                            </Row>

                            <TableOne tpaDailyReportPid={props.tpaDailyReportPid} readOnly={true} />

                            <Row>
                                <label className="d-sm-flex align-items-center justify-content-start mt-3 ms-5" style={{ fontSize: "16px", color: "#FFFFFF" }}>
                                    ตารางที่ 2 ข้อมูลสรุปการบริหารปริมาณก๊าซสำหรับระบบส่งก๊าซธรรมชาติบนบก (ข้อมูล Operation)
                                </label>
                            </Row>

                            <TableTwo tpaDailyReportPid={props.tpaDailyReportPid} readOnly={true} />

                            <Row>
                                <label className="d-sm-flex align-items-center justify-content-start mt-3 ms-5" style={{ fontSize: "16px", color: "#FFFFFF" }}>
                                    ตารางที่ 3 ข้อมูลปริมาณ Shrinkage Gas และตัวแปรอื่นๆ สำหรับระบบส่งก๊าซธรรมชาติบนบก (ข้อมูล Operation)
                                </label>
                            </Row>

                            <TableThree tpaDailyReportPid={props.tpaDailyReportPid} readOnly={true} />

                            <Row>
                                <label className="d-sm-flex align-items-center justify-content-start mt-5" style={{ fontSize: "18px", color: "#FFFFFF" }}>
                                    2. สรุปข้อมูลการบริหารสมดุลสำหรับระบบส่งก๊าซธรรมชาติบนบก
                                </label>
                            </Row>

                            <Row>
                                <label className="d-sm-flex align-items-center justify-content-start mt-3 ms-5" style={{ fontSize: "16px", color: "#FFFFFF" }}>
                                    ตารางที่ 4 ข้อมูลสรุปการบริหารสมดุลสำหรับระบบส่งก๊าซธรรมชาติบนบก
                                </label>
                            </Row>

                            <TableFour tpaDailyReportPid={props.tpaDailyReportPid} readOnly={true} />

                            <Row>
                                <label className="d-sm-flex align-items-center justify-content-start mt-5" style={{ fontSize: "18px", color: "#FFFFFF" }}>
                                    3. ข้อมูลคำนวณความสามารถในการให้บริการเกินกำหนดสำหรับจุดที่มีมาตรวัดรายวัน
                                </label>
                            </Row>

                            <Row>
                                <label className="d-sm-flex align-items-center justify-content-start mt-3 ms-5" style={{ fontSize: "16px", color: "#FFFFFF" }}>
                                    ตารางที่ 5 ข้อมูลสรุปการใช้ก๊าซของลูกค้า แบ่งตามกลุ่มพื้นที่จุดจ่ายออกต่างๆ
                                </label>
                            </Row>

                            <Row>
                                <OveruseByContact shipperName={modelDevice.BALANCESHIPPER_NAME} shipperPid={modelDevice.BALANCESHIPPER_PID} summaryReportPid={modelDevice.SUMMARYREPORT_PID} />
                            </Row>
                            <Row>
                                <OveruseByShipper shipperName={modelDevice.BALANCESHIPPER_NAME} summaryReportPid={modelDevice.SUMMARYREPORT_PID} />
                            </Row>

                        </CardBody>
                    )}
                    {props.tpaDailyReportPid == null && (
                        <CardBody>
                            {/* <Row>
                        <h5> ไม่มีข้อมูล TPA Final Allocation ของวันที่..... หากต้องการดำเนินการสามารถไปจัดการข้อมูลได้ในหน้า Summary Report ของวันที่ .... </h5>
                            </Row> */}
                            <Row>
                                {/* <Col sm="1" className="align-items-center justify-content-start">
                                    <i className="bx bxs-right-arrow-circle bx-fade-right text-danger display-6" />
                                </Col> */}
                                <Col sm="1" className="d-sm-flex align-items-center justify-content-end">
                                    <i className="bx bx-chevrons-right bx-fade-right text-danger display-6" />
                                </Col>
                                <Col sm="11" className="d-sm-flex align-items-center justify-content-start">
                                    <h5 className="mb-0" style={{fontSize: "19px"}}> ไม่มีข้อมูล TPA Final Allocation ของวันที่ {moment(props.date).locale('th').add(543, 'year').add(-3, 'day').format("LL")}&nbsp;
                                        หากต้องการดำเนินการสามารถไปจัดการข้อมูลได้ในหน้า Summary Report ของวันที่ {moment(props.date).locale('th').add(543, 'year').add(-3, 'day').format("LL")}  </h5>
                                    {/* <i className="bx bxs-left-arrow-circle bx-fade-left text-danger display-6" /> */}
                                    {/* <i className="bx bx-bell bx-tada text-danger display-6" />
                                        <i className="bx bx-buoy bx-spin text-primary display-6" /> */}
                                    {/* </div> */}
                                    {/* bx bx-help-circle */}
                                    {/* <i className="bx bx-down-arrow-circle h1 text-primary down-arrow-icon"></i> */}
                                </Col>
                            </Row>
                        </CardBody>
                    )}
                </Card>
            </Col>


        </React.Fragment >
    );
}

TabTwoTPADailyDetail.propTypes = {
    t: PropTypes.any,
    tpaDailyReportPid: PropTypes.any,
    date: PropTypes.any,
};


export default TabTwoTPADailyDetail;
